import React from "react";
import { Link } from "react-router-dom-v5-compat";
import { Handle, Position } from "@xyflow/react";
import Icon from "../Icon";
import { url } from "../../utils";

type Props = {
  data?: {
    id: string;
    label: string;
    href?: string;
    type?: string;
    icon?: string;
    isFirst?: boolean;
    isLast?: boolean;
    disabled?: boolean;
  };
};

function CustomNode({
  data: {
    // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{ id: string... Remove this comment to see the full error message
    id,
    // @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type '{ id: stri... Remove this comment to see the full error message
    icon,
    // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '{ id: stri... Remove this comment to see the full error message
    type,
    // @ts-expect-error TS(2339) FIXME: Property 'href' does not exist on type '{ id: stri... Remove this comment to see the full error message
    href,
    // @ts-expect-error TS(2339) FIXME: Property 'label' does not exist on type '{ id: str... Remove this comment to see the full error message
    label,
    // @ts-expect-error TS(2339) FIXME: Property 'isFirst' does not exist on type '{ id: s... Remove this comment to see the full error message
    isFirst = false,
    // @ts-expect-error TS(2339) FIXME: Property 'isLast' does not exist on type '{ id: st... Remove this comment to see the full error message
    isLast = false,
    // @ts-expect-error TS(2339) FIXME: Property 'disabled' does not exist on type '{ id: ... Remove this comment to see the full error message
    disabled,
  },
}: Props) {
  const leftHandle = !isFirst && (
    <Handle className="handle" type="target" position={Position.Left} />
  );

  const rightHandle = !isLast && (
    <Handle className="handle" type="source" position={Position.Right} />
  );

  const header = icon && type && (
    <div className="header">
      {icon && <Icon name={icon} />}
      <span>{type}</span>
    </div>
  );

  return (
    <div
      id={`custom-node-${id}`}
      data-current={isLast}
      data-disabled={!!disabled}
      className="custom-node"
    >
      {leftHandle}
      {header}
      <div className="content">
        {isLast || disabled || !href ? (
          <span>{label}</span>
        ) : (
          <Link to={url(href)}>{label}</Link>
        )}
      </div>
      {rightHandle}
    </div>
  );
}

export default React.memo(CustomNode);
